import React from 'react';
import Notfound from './../assets/images/not_found.webp';
import { useHistory } from 'react-router';

const NotFound = () => {
  const history = useHistory();

  return (
    <div className="overview-page">
      <div className="container-fluid main-overview">
        <div className="row">
          <div className="col-xl-12 d-flex content py-3">
            <div
              className="card text-center w-100 d-flex justify-content-center align-items-center"
              style={{ height: '95vh' }}
            >
              <img src={Notfound} height="300" width="500" />
              <h5 style={{ color: '#3c64b1' }}>Maaf, halaman yang Anda tuju tidak ditemukan</h5>
              <h6 className="mb-4">Kembali ke Halaman Utama</h6>
              <button
                onClick={() => {
                  history.push({ pathname: '/', state: { pageChannel: 'Not Found Page' } });
                }}
                className="btn-overview-green-solid-hovered my-2 my-sm-0 mr-3"
                type="submit"
                style={{ width: 200 }}
              >
                Kembali Kehalaman Depan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
